import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.access');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type KioskMode = 'main' | 'drink' | 'door' | 'parking' | 'room' | 'staff';

@Component({
    selector: 'wiz-page-access',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.access/view.scss */
:host {
  display: block;
}`],
})
export class PageAccessComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public ngOnInit() {
        setTimeout(() => this.redirectToKiosk(), 0);
    }

    private redirectToKiosk() {
        const params = new URLSearchParams(window.location.search);
        const mode = this.normalizeMode(params.get('mode')) || 'main';
        params.delete('mode');

        const query = params.toString();
        this.service.href(`/kiosk/${mode}${query ? `?${query}` : ''}`);
    }

    private normalizeMode(mode: string | null): KioskMode | null {
        if (mode === 'main' || mode === 'drink' || mode === 'door' || mode === 'parking' || mode === 'room' || mode === 'staff') return mode;
        return null;
    }
}

export default PageAccessComponent;